window.dataLayer = window.dataLayer || [];
function gtagConcentMode(){dataLayer.push(arguments);}
// Function to set a cookie
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function consentDefault() {
  let marketingAllowed = getCookie('marketingAllowed') == 'true' ? true : 'x';
  let analyticsProcessingAllowed = getCookie('analyticsProcessingAllowed') == 'true' ? true : 'x';
  let preferencesProcessingAllowed = getCookie('preferencesProcessingAllowed') == 'true' ? true : 'x';
  if(getCookie('marketingAllowed') === null){
    console.log('dont found cookies set all on default');
    marketingAllowed = true;
    analyticsProcessingAllowed = true
    preferencesProcessingAllowed = true;
        setCookie('marketingAllowed', marketingAllowed, 180);
        setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, 180);
        setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, 180);
  }
  gtagConcentMode('consent', 'default', {
    'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
    'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
    'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
    'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
  });
  dataLayer.push({event:'concent_initializing'});
  
}
consentDefault();
document.addEventListener('readystatechange', function (event) {
  if (event.target.readyState === "complete") {
    initCookies();
  }
});
function initCookies () {
  const consentFooter = document.getElementById('custom-consent-footer');
  const overlay = document.getElementById('custom-consent-overlay');
  const consentPopup = document.getElementById('custom-consent-popup');
  const openConsentButton = document.getElementById('openConsentPopup');
  const saveConsentButton = document.getElementById('saveConsent');
  const saveAcceptConsentAll = document.querySelectorAll('.cookies-concent-save-all');
  const declineConsentAll = document.querySelectorAll('.cookies-concent-decline-all');
  const closePopupButton = document.getElementById('closeConsentPopup');
  const closeFooterButton = document.getElementById('closeFooterPopup');
  const cookieSettingsAnchors = document.querySelectorAll('a[href="#cookie-settings"]');
  const showMoreButton = document.querySelector('#custom-consent-footer button.show-more');
  // console.log(window.Shopify)
  // console.log(window.Shopify.loadFeatures)
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) {
        console.log('we can no use consent settings from shopify');
      } else {
        let marketingAllowed = window.Shopify.customerPrivacy.marketingAllowed() == true ? true : 'x';
        let analyticsProcessingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed() == true ? true : 'x';
        let preferencesProcessingAllowed = window.Shopify.customerPrivacy.preferencesProcessingAllowed() == true ? true : 'x';

        // console.log('loading page with cookies');
        // console.log('marketingAllowed',getCookie('marketingAllowed'), marketingAllowed);
        // console.log('analyticsProcessingAllowed',getCookie('analyticsProcessingAllowed'), analyticsProcessingAllowed);
        // console.log('preferencesProcessingAllowed', getCookie('preferencesProcessingAllowed'),preferencesProcessingAllowed);

        // if(getCookie('marketingAllowed') === null){
        //   console.log('dont found cookies set all on default');
        //   marketingAllowed = 'x';
        //   analyticsProcessingAllowed = 'x';
        //   preferencesProcessingAllowed = 'x';
        //   const consentOptions = {
        //     marketing: false,
        //     analytics: false,
        //     preferences: false
        //   };
        //   window.Shopify.customerPrivacy.setTrackingConsent(
        //     consentOptions,
        //     () => {
        //       consentPopup.style.display = 'none';
        //       overlay.style.display = 'none';
        //       consentFooter.style.display = 'flex';
        //       localStorage.setItem("privacy-concent", "false");
        //     }
        //   );
        //   document.getElementById("marketingAllowed").checked = true;
        //   document.getElementById("analyticsAllowed").checked = true;
        //   document.getElementById("preferencesAllowed").checked = true;
        // } else {
          document.getElementById("marketingAllowed").checked = marketingAllowed == true ? true : false;
          document.getElementById("analyticsAllowed").checked = analyticsProcessingAllowed == true ? true : false;
          document.getElementById("preferencesAllowed").checked = preferencesProcessingAllowed == true ? true : false;
        // }
        setCookie('marketingAllowed', marketingAllowed, 180);
        setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, 180);
        setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, 180);
        console.log('calling gtagConcentMode on load');
        gtagConcentMode('consent', 'update', {  
          'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
          'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
          'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
          'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
        });
        dataLayer.push({event:'concent_updating'});
        if(localStorage.getItem("privacy-concent") === null || localStorage.getItem("privacy-concent") === "false"){
          consentFooter.style.display = 'flex';
        }
      }
    },
  );

  if (openConsentButton && consentPopup) {

    openConsentButton.addEventListener('click', function() {
      consentPopup.style.display = 'block';
      overlay.style.display = 'block';
    });

    cookieSettingsAnchors.forEach(function(el){
      el.addEventListener('click', function(e) {
        e.preventDefault();
        consentPopup.style.display = 'block';
        overlay.style.display = 'block';
      });
    })

  }

  if (saveConsentButton) {
    closeFooterButton.addEventListener('click', function(){
      consentFooter.style.display = 'none';
      localStorage.setItem("privacy-concent", "true");
    })
    closePopupButton.addEventListener('click', function(){
      consentPopup.style.display = 'none';
      overlay.style.display = 'none';
    })
    saveConsentButton.addEventListener('click', function() {
      savePreferences();
    });
    saveAcceptConsentAll.forEach(function(el){
      el.addEventListener('click', function() {
        document.getElementById('marketingAllowed').checked = true;
        document.getElementById('analyticsAllowed').checked = true;
        document.getElementById('preferencesAllowed').checked = true;
        savePreferences();
      });
    });
    declineConsentAll.forEach(function(el){
      el.addEventListener('click', function() {
        document.getElementById('marketingAllowed').checked = false;
        document.getElementById('analyticsAllowed').checked = false;
        document.getElementById('preferencesAllowed').checked = false;
        savePreferences();
      });
    });
    showMoreButton.addEventListener('click', function() {
      const showMoreContent = document.querySelector('#custom-consent-footer p');
      showMoreContent.classList.toggle('show');
    });
  }
}
function savePreferences () {
  const consentPopup = document.getElementById('custom-consent-popup');
  const overlay = document.getElementById('custom-consent-overlay');
  const consentFooter = document.getElementById('custom-consent-footer');

  const marketingAllowed =  document.getElementById('marketingAllowed').checked  == true ? true :  'x';
  const analyticsProcessingAllowed =  document.getElementById('analyticsAllowed').checked  == true ? true :  'x';
  const preferencesProcessingAllowed =  document.getElementById('preferencesAllowed').checked  == true ? true :  'x';

  setCookie('marketingAllowed', marketingAllowed, 180);
  setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, 180);
  setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, 180);
  gtagConcentMode('consent', 'update', {  
    'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
    'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
    'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
    'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
  });
  dataLayer.push({event:'concent_updating'});
  const consentOptions = {
    marketing: marketingAllowed == true ? true : false,
    analytics: analyticsProcessingAllowed == true ? true : false,
    preferences: preferencesProcessingAllowed == true ? true : false
  };
  window.Shopify.customerPrivacy.setTrackingConsent(
    consentOptions,
    () => {
      consentPopup.style.display = 'none';
      overlay.style.display = 'none';
      consentFooter.style.display = 'none';
      localStorage.setItem("privacy-concent", "true");
    }
  );
}